
const setUserList = (state, userList) => {
  state.userList = userList;
};


export default {
  setUserList
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js